  import React from "react";

  import {
    HeroCarousel,
    StatsSection,
    ActivitiesSection,
    AboutSection,
    ExploreDivisionSection,
  } from "../components/Home";

  import Navbar from "../components/Layout/Navbar";
  import Footer from "../components/Layout/Footer";

  import { useSliders } from "../hooks/useData";

  export default function Home() {
    const { data: sliders, loading: slidersLoading } = useSliders();
    console.log("Sliders data:", sliders);
    if (slidersLoading) {
      return <div>Loading...</div>;
    }

    return (
      <>
        <Navbar />
        <HeroCarousel sliders={sliders} />
        <StatsSection />
        <ActivitiesSection />
        <AboutSection />
        <ExploreDivisionSection />
        <Footer />
      </>
    );
  }
